import { RgDataSetID } from '../rg-data-set-id.js';
import { ManualRvData as ManualRvData$1 } from './internal/shared/manual-rv-data.js';
import { CombinedRvData } from './internal/uk-01/combined-rv-data.js';
import { ManualRvData } from './internal/uk-01/manual-rv-data.js';
import { CombinedRvData as CombinedRvData$1 } from './internal/uk-02/combined-rv-data.js';

/** Record of the available sets of `RvData` according to a given `RgDataSetID` */
const RvDataListSets = {
    [RgDataSetID.uk_01]: CombinedRvData.concat(ManualRvData, ManualRvData$1),
    [RgDataSetID.uk_02]: CombinedRvData$1.concat(ManualRvData$1)
};

export { RvDataListSets };
//# sourceMappingURL=rv-data-list-sets.js.map
